// ===== Return to Top ====
const config = {
    returnButtonSelector: '.c-return-to-top',
    showModifier: 'is-open'
};

const returnButtonSelector = $(config.returnButtonSelector);

$(window).scroll(function() {
    if ($(this).scrollTop() >= 1000) {
        $(returnButtonSelector).addClass(config.showModifier);
    } else {
        $(returnButtonSelector).removeClass(config.showModifier);
    }
});

$(returnButtonSelector).click(function() {
    $('body,html').animate({ scrollTop : 0 }, 500);
});



// WEBPACK FOOTER //
// ./src/js/components/return-to-top.js